import CardRegistrationView from '../Views/CardRegistrationView';

const cardRegistration = [
          {
            path: '/',
            component: CardRegistrationView,
            name: 'CardRegistrationView',
            meta: { 
              name: {
                es: 'Registro de Tarjeta', 
                en: 'Card Registration'
              }, 
              group: 'portalalumno.payments', 
              path: 'card_registration', 
              permission: 'READ' 
            }
        }
];

export default cardRegistration
